import Immutable from 'immutable';
import moment from 'moment';

import type ErrorData from 'sharedreact/data/ErrorData';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

import LoadHistoryConnection from 'workspaces/launcher/connections/LoadHistoryConnection';
import LoadHistoryConstants from 'workspaces/launcher/constants/LoadHistoryConstants';
import LoadHistoryRange from 'workspaces/launcher/constants/LoadHistoryRange';

function _fetchSuccess (
  what: string,
  start: number,
  end: number,
  items: Immutable.List<any>,
  fetchInfo: Immutable.Map<string, any>
) {
  const fetchId = Date.now().toString(36);
  if (!fetchInfo.get('isComplete')) {
    AppDispatcher.dispatch({
      actionType: LoadHistoryConstants.GET_SUCCESS,
      items: items.pop(),
      what: what,
      start: start,
      end: end,
      fetchId: fetchId,
      fetchInfo: fetchInfo,
      logLevel: 'debug'
    });
  } else {
    AppDispatcher.dispatch({
      actionType: LoadHistoryConstants.GET_SUCCESS,
      items: items,
      what: what,
      start: start,
      end: end,
      fetchId: fetchId,
      fetchInfo: fetchInfo,
      logLevel: 'debug'
    });
  }
}

function _fetchMoreSuccess (what: string, fetchId: string, start: number, end: number, startRecord: number, items: Immutable.List<any>, fetchInfo: Immutable.Map<string, any>) {
  AppDispatcher.dispatch({
    actionType: LoadHistoryConstants.GETMORE_SUCCESS,
    items: items,
    what: what,
    start: start,
    end: end,
    fetchId: fetchId,
    fetchInfo: fetchInfo,
    logLevel: 'debug'
  });
}

function _fetchFailure (what: string, error: ErrorData) {
  AppDispatcher.dispatch({
    actionType: LoadHistoryConstants.GET_FAIL,
    error: error,
    what: what,
    logLevel: 'debug'
  });
}

function fetch (what: string, start: number, end: number, maxSamples: number) {
  AppDispatcher.dispatch({
    actionType: LoadHistoryConstants.FETCH_STARTED,
    what: what,
    logLevel: 'debug'
  });
  LoadHistoryConnection.fetch(what, start, end, maxSamples, _fetchSuccess, _fetchFailure);
}

function fetchMore (what: string, fetchId: string, start: number, end: number, startRecord: number, sampleInterval: number) {
  LoadHistoryConnection.fetchMore(what, fetchId, start, end, startRecord, sampleInterval, _fetchMoreSuccess, _fetchFailure);
}

function fetchRange (what: string, start: number, range: string, maxSamples: number) {
  AppDispatcher.dispatch({
    actionType: LoadHistoryConstants.FETCH_RANGE_STARTED,
    what: what,
    range: range,
    logLevel: 'debug'
  });

  LoadHistoryConnection.fetch(what, start, 0, maxSamples, _fetchSuccess, _fetchFailure);
}

function fetchInitial (what: string, maxSamples: number) {
  // fetch all
  AppDispatcher.dispatch({
    actionType: LoadHistoryConstants.FETCH_RANGE_STARTED,
    what: what,
    range: LoadHistoryRange.RANGE_LAST3MONTH,
    logLevel: 'debug'
  });
  const now = moment();
  const startTime : number = now.subtract(3, 'month').valueOf();
  LoadHistoryConnection.fetch(what, startTime, 0, maxSamples, _fetchSuccess, _fetchFailure);
}

function clearAll () {
  AppDispatcher.dispatch({
    actionType: LoadHistoryConstants.CLEAR_ALL,
    logLevel: 'debug'
  });
}

function setMaxSamples (value: number) {
  AppDispatcher.dispatch({
    actionType: LoadHistoryConstants.SET_MAX_SAMPLES,
    logLevel: 'debug',
    value: value
  });
}

const LoadHistoryActions = {
  fetch,
  fetchInitial,
  fetchRange,
  fetchMore,
  clearAll,
  setMaxSamples
};

export default LoadHistoryActions;